module.exports = __webpack_public_path__ + "img/css.f5da6f25.svg";